// src/components/KMUI/KTextField.tsx

import { VisibilityTwoTone, VisibilityOffTwoTone } from '@mui/icons-material'
import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material'
import { ComponentProps, ReactNode, useState } from 'react'

const stopBubbling = event => event.stopPropagation()

type Props = {
  icon?: ReactNode
  max?: number
  min?: number
  readOnly?: boolean
  type?: string
  unit?: ReactNode
} & ComponentProps<typeof TextField>

export const KTextField = ({
  icon,
  max,
  min,
  readOnly,
  type,
  unit,
  ...rest
}: Props) => {
  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => setShowPassword(!showPassword)

  return (
    <FormControl fullWidth>
      <TextField
        InputProps={{
          startAdornment: icon && (
            <InputAdornment position={'start'}>{icon}</InputAdornment>
          ),

          endAdornment: (
            <InputAdornment position={'end'}>
              {type === 'password' && (
                <IconButton onClick={togglePassword} onMouseDown={stopBubbling}>
                  {showPassword ? (
                    <VisibilityTwoTone />
                  ) : (
                    <VisibilityOffTwoTone />
                  )}
                </IconButton>
              )}
              {unit && unit}
            </InputAdornment>
          ),
          readOnly,
          inputProps: { min, max },
        }}
        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
        {...rest}
      />
    </FormControl>
  )
}
